import React from "react";
import Layout from "../layouts/index.jsx";
import Header from "../layouts/header";
import IntroContainer from "../containers/home/intro";
import DirectorContainer from "../containers/home/director";
import MedicalFeatureContainer from "../containers/home/medical-feature";
import AppointmentContainer from "../containers/home/appointment";
import GoogleMapContainer from "../containers/global/map";
import Footer from "../layouts/footer";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import SeoData from "../data/seo.json";

const HomePage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO {...SeoData["/"]} pathname="/" />
                <div className="wrapper home-default-wrapper">
                    <Header />
                    <div className="main-content site-wrapper-reveal">
                        <IntroContainer />
                        <DirectorContainer />
                        <MedicalFeatureContainer />
                        <AppointmentContainer />
                        <GoogleMapContainer withHeading />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default HomePage;
